import React from 'react';
import {MovieList} from '../components/Movie/MovieList';

export default function Home() {
  return <MovieList where={{hasVideo: true}} />;
}
